import { neutralLight } from '@crehana/tailwindcss/colors';
// biome-ignore lint/style/noRestrictedImports: legacy code - style/noRestrictedImports
import styled from 'styled-components';

export const Container = styled.section`
  display: flex;
  background-color: transparent;
  padding: 16px 0px;
  margin-bottom: 42px;
  @media (max-width: 768px) {
    width: 100%;
    justify-content: center;
    background-color: ${neutralLight['200']};
    margin-bottom: 0px;
  }
`;
